"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.NewsletterForm = void 0;
var vue_1 = require("vue");
var fetch_1 = __importDefault(require("../utils/fetch"));
var Spinner_1 = require("./Spinner");
exports.NewsletterForm = vue_1.defineComponent({
    name: 'NewsletterForm',
    components: { Spinner: Spinner_1.Spinner },
    props: {
        nameLabel: { type: String, required: true },
        emailLabel: { type: String, required: true },
    },
    setup: function () {
        var form = vue_1.ref({
            name: { value: '', error: '' },
            email: { value: '', error: '' },
            acceptPP: { value: false, error: '' },
        });
        var submitButtonDisabled = vue_1.ref(false);
        var submitSuccess = vue_1.ref(false);
        var onSubmit = function () {
            submitButtonDisabled.value = true;
            form.value.name.error = '';
            form.value.email.error = '';
            form.value.acceptPP.error = '';
            fetch_1["default"]('/api/newsletters/subscribe', {
                method: 'POST',
                body: JSON.stringify({
                    name: form.value.name.value,
                    email: form.value.email.value,
                })
            }).then(function (response) {
                form.value.name.value = '';
                form.value.email.value = '';
                form.value.acceptPP.value = false;
                submitSuccess.value = true;
                window.setTimeout(function () {
                    submitSuccess.value = false;
                }, 5000);
            })["catch"](function (error) {
                if (error.response.hasOwnProperty('email')) {
                    form.value.email.error = error.response.email;
                }
            })["finally"](function () {
                submitButtonDisabled.value = false;
            });
        };
        return {
            form: form,
            onSubmit: onSubmit,
            submitButtonDisabled: submitButtonDisabled,
            submitSuccess: submitSuccess,
        };
    },
    template: /* html */ "\n        <form @submit.prevent=\"onSubmit\" class=\"flex flex-col gap-8 text-18\">\n            <input\n                v-model=\"form.name.value\"\n                type=\"text\"\n                name=\"name\"\n                required\n                :placeholder=\"nameLabel\"\n                class=\"w-full bg-white text-black rounded-5 px-9 py-6 outline-none\">\n            <div>\n                <input\n                    v-model=\"form.email.value\"\n                    type=\"text\"\n                    name=\"email\"\n                    required\n                    :placeholder=\"emailLabel\"\n                    class=\"w-full bg-white text-black rounded-t-5 px-9 py-6 outline-none\"\n                    :class=\"{ 'rounded-b-5': !form.email.error.length, 'border': form.email.error.length, 'border-red': form.email.error.length }\">\n                <div v-if=\"form.email.error.length\" class=\"bg-red px-9 py-6 rounded-b-5 font-medium\">\n                    {{ form.email.error }}\n                </div>\n            </div>\n            <label class=\"flex flex-row items-center justify-between gap-12 text-18 md:text-12\">\n                <input\n                    v-model=\"form.acceptPP.value\"\n                    type=\"checkbox\"\n                    name=\"accept_pp\"\n                    required\n                    class=\"w-24 h-24\">\n                <slot name=\"accept-pp-label\"></slot>\n            </label>\n            <button\n                v-if=\"!submitSuccess\"\n                type=\"submit\"\n                class=\"uppercase font-bold text-green bg-white w-full rounded-full py-6 tracking-wider disabled:opacity-50\"\n                :disabled=\"submitButtonDisabled\">\n                <template v-if=\"!submitButtonDisabled\">\n                    <slot name=\"submit-button-text\"></slot>\n                    <i class=\"icon-chevron-right text-12 ml-2\"></i>\n                </template>\n                <spinner v-else class=\"fill-current text-green w-1em h-1em animate-spin inline-block\" />\n            </button>\n            <div v-else class=\"uppercase font-bold text-green text-center bg-white w-full rounded-5 py-6 tracking-wide\">\n                Sikeres feliratkoz\u00E1s.\n            </div>\n        </form>\n    "
});
